/**
 * @module math
 */

/**
 * @sig degreesToRadians :: Number -> Number
 */
const degreesToRadians = degrees => degrees * (Math.PI / 180);

/**
 * Calculates the great-circle distance (in meters) between two Lat/Lngs
 * @sig greatCircleDistance :: (Lat, Lng, Lat, Lng) -> Number
 */
const greatCircleDistance = (lat1, lng1, lat2, lng2) => {
    const RADIUS = 6371000; // of the earth--in meters
    const phi1 = degreesToRadians(lat1);
    const phi2 = degreesToRadians(lat2);
    const deltaPhi = degreesToRadians(lat2 - lat1);
    const deltaLamba = degreesToRadians(lng2 - lng1);

    const a =
        Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
        Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLamba / 2) * Math.sin(deltaLamba / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return RADIUS * c;
};

/**
 * Is x between low and high (inclusive on both ends)?
 * @sig isBetween :: (Number, Number, Number) -> Boolean
 */
const isBetween = (low, x, high) => low <= x && x <= high;

export { degreesToRadians, isBetween, greatCircleDistance };
